(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["differenciation-clario-inverse"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('sectionClarioInverse');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('show');
        }
      });
    },
    {
      threshold: 0.4,
    }
  );

  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["differenciation-clario"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('sectionClarioInverse');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('show');
        }
      });
    },
    {
      threshold: 0.4,
    }
  );

  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
